function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import router from './router';
import store from './store';
import { Message, MessageBox } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/auth-redirect']; // no redirect whitelist

router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from, next) {
    var isEdit, hasToken, hasRoles, roles, accessRoutes, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          isEdit = store.getters.isEdit;
          if (!isEdit) {
            _context.n = 1;
            break;
          }
          MessageBox.confirm('离开该编辑页面，已编辑信息会丢失，请问您确认离开吗？', '提示', {
            confirmButtonText: '离开',
            cancelButtonText: '不离开',
            confirmButtonClass: 'btnTrue',
            cancelButtonClass: 'btnFalse',
            type: 'warning'
          }).then(function () {
            store.dispatch("settings/setEdit", false);
            // start progress bar
            NProgress.start();

            // set page title
            document.title = getPageTitle(to.meta.title);

            // determine whether the user has logged in
            var hasToken = getToken();
            if (hasToken) {
              if (to.path === '/login') {
                // 检查是否有平台登录参数，如果有则允许访问登录页面
                if (to.query.id && to.query.token) {
                  next();
                } else {
                  // if is logged in, redirect to the home page
                  next({
                    path: '/'
                  });
                  NProgress.done();
                }
              } else {
                var hasRoles = store.getters.roles && store.getters.roles.length > 0;
                if (hasRoles) {
                  next();
                } else {
                  try {
                    var roles = store.dispatch('user/getInfo');
                    var accessRoutes = store.dispatch('permission/generateRoutes', roles);
                    router.addRoutes(accessRoutes);
                    next(_objectSpread(_objectSpread({}, to), {}, {
                      replace: true
                    }));
                  } catch (error) {
                    // remove token and go to login page to re-login
                    store.dispatch('user/resetToken');
                    Message.error(error || 'Has Error');
                    next("/login?redirect=".concat(to.path));
                    NProgress.done();
                  }
                }
              }
            } else {
              /* has no token*/
              if (whiteList.indexOf(to.path) !== -1) {
                // in the free login whitelist, go directly
                next();
              } else {
                // other pages that do not have permission to access are redirected to the login page.
                next("/login?redirect=".concat(to.path));
                NProgress.done();
              }
            }
          });
          _context.n = 10;
          break;
        case 1:
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.n = 9;
            break;
          }
          if (!(to.path === '/login')) {
            _context.n = 2;
            break;
          }
          // 检查是否有平台登录参数，如果有则允许访问登录页面
          if (to.query.id && to.query.token) {
            next();
          } else {
            // if is logged in, redirect to the home page
            next({
              path: '/'
            });
            NProgress.done();
          }
          _context.n = 8;
          break;
        case 2:
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (!hasRoles) {
            _context.n = 3;
            break;
          }
          next();
          _context.n = 8;
          break;
        case 3:
          _context.p = 3;
          _context.n = 4;
          return store.dispatch('user/getInfo');
        case 4:
          roles = _context.v;
          _context.n = 5;
          return store.dispatch('permission/generateRoutes', roles);
        case 5:
          accessRoutes = _context.v;
          router.addRoutes(accessRoutes);
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.n = 8;
          break;
        case 6:
          _context.p = 6;
          _t = _context.v;
          _context.n = 7;
          return store.dispatch('user/resetToken');
        case 7:
          Message.error(_t || 'Has Error');
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        case 8:
          _context.n = 10;
          break;
        case 9:
          /* has no token*/
          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            NProgress.done();
          }
        case 10:
          return _context.a(2);
      }
    }, _callee, null, [[3, 6]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});